function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as e } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: o , size: c = 24  } = _param, h = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = e(), t = o !== null && o !== void 0 ? o : l ? r.colors.inverse : r.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ a("path", {
            fill: t,
            d: "M12.492 2c-3.13 0-5.68 2.665-5.68 5.938 0 3.273 2.55 5.939 5.68 5.939a5.4 5.4 0 002.358-.542.379.379 0 00.177-.494.35.35 0 00-.472-.185 4.745 4.745 0 01-2.063.475c-2.74 0-4.97-2.328-4.97-5.193 0-2.864 2.23-5.197 4.97-5.197 2.74 0 4.97 2.333 4.97 5.197a5.33 5.33 0 01-.277 1.7.374.374 0 00.219.471.348.348 0 00.45-.228 6.063 6.063 0 00.317-1.943C18.171 4.665 15.623 2 12.492 2zm8.537 14.342c-.186-.589-.704-.983-1.29-.983-.241 0-.477.066-.682.19l-2.662 1.624c-.018-.802-.645-1.444-1.418-1.444H9.752l-.808-.508a1.69 1.69 0 00-.886-.238H3.264a.363.363 0 00-.354.37c0 .205.159.372.354.372h2.84v4.08c0 .613-.477 1.112-1.063 1.112H3.264a.363.363 0 00-.354.37c0 .205.159.371.354.371h1.777c.577 0 1.086-.295 1.413-.741h2.449l3.957 1.026a1.736 1.736 0 001.327-.19l6.192-3.739a1.461 1.461 0 00.65-1.672zm-1.004 1.036l-6.193 3.738a1.02 1.02 0 01-.804.114L9.03 20.19l-2.254-.01c.023-.118.037-.247.037-.375v-4.08h1.24c.205 0 .382.047.527.133l.972.608h5.425c.391 0 .709.332.709.74 0 .41-.318.742-.709.742h-3.902a.363.363 0 00-.355.37c0 .205.16.37.354.37h3.903c.35 0 .668-.137.913-.355l3.526-2.152a.62.62 0 01.318-.09.66.66 0 01.618.47.719.719 0 01-.327.817zm-3.63-6.47c.39 0 .709.332.709.74 0 .409-.319.742-.71.742-.39 0-.708-.333-.708-.742 0-.408.318-.74.709-.74zm-3.548-3.9H11.21c.35-.557.954-.927 1.636-.946.313 0 .617.08.9.233a.346.346 0 00.476-.157.378.378 0 00-.15-.499 2.557 2.557 0 00-1.231-.314c-1.09 0-2.026.69-2.44 1.673h-.754a.363.363 0 00-.354.37c0 .204.159.37.354.37h.559a2.539 2.539 0 000 .742h-.56a.363.363 0 00-.353.37c0 .205.159.37.354.37h.754c.414.984 1.35 1.673 2.44 1.673.431 0 .845-.104 1.231-.313a.378.378 0 00.15-.5.345.345 0 00-.477-.156 1.819 1.819 0 01-.9.233c-.686 0-1.285-.37-1.635-.927h1.636a.363.363 0 00.354-.37.363.363 0 00-.354-.37h-1.918a2.436 2.436 0 01-.032-.371c0-.128.01-.252.032-.37h1.918a.363.363 0 00.354-.371.363.363 0 00-.354-.37z"
        })
    }));
}, v = i;
export { v as default };
